var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "nudge-bottom": "48",
        "nudge-right": "18",
        "content-class": "navigation-context-menu",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(
                  _vm._b(
                    { class: [_setup.iconConfig, "main-icon"] },
                    "span",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { staticClass: "list" },
        _vm._l(_setup.items, function (item, index) {
          return item.show
            ? _c(
                "v-list-item",
                {
                  key: index,
                  staticClass: "list-item",
                  on: {
                    click: function ($event) {
                      return _setup.redirect(item)
                    },
                  },
                },
                [
                  _c("span", { class: [item.icon, "lf-icon__lg"] }),
                  _c("span", [_vm._v(_vm._s(item.name))]),
                ]
              )
            : _vm._e()
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }